import React, { Component } from 'react';
import NotificationSystem from 'react-notification-system';

import Api from '../../Services/Api';

export default class EmailConfirmationPage extends Component {
  constructor(props) {
    super(props);

    this.state = props.match.params;

    this.postForm = this.postForm.bind(this);
  }

  componentDidMount() {
    this.postForm();
  }

  postForm() {
    this.request = Api.get('email_confirmation', {
      method: 'POST',
      body: JSON.stringify({
        confirmationToken: this.state.confirmationToken,
      }),
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }
    }, false, false).then((response) => {
      this.refs.notificationSystem.addNotification({
        message: response.message,
        level: 'success',
        position: 'tc'
      });
      setTimeout(() => {
        this.props.history.push('/login');
      }, 2500);
    }).catch((error) => {
      console.error(error);
    });
  }

  render() {
    return (
      <div>
        <NotificationSystem ref="notificationSystem" />
      </div>);
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Authentication/EmailConfirmationPage.js